export default "__VITE_ASSET__BwCc5JVH__"